import { getApolloClient } from '../lib/getApolloClient';
import { GET_INTEGRATION_CONNECTIONS_FOR_TENANT } from './integration.gql';
import {
  IntegrationConnection,
  IntegrationInitializationSchema,
  SupportedIntegrationPlatform,
} from '../generated/gql-types';

export type IntegrationConnectionListItem = Pick<
  IntegrationConnection,
  'id' | 'integrationId' | 'tenantId' | 'integrationEnabled'
>;

export type IntegrationFetchResult = {
  connections: IntegrationConnectionListItem[];
  platformByIntegrationId: Record<string, SupportedIntegrationPlatform>;
};

export const integrationActions = {
  fetchIntegrationDataForTenant: async (
    tenantId: string,
  ): Promise<IntegrationFetchResult | null> => {
    try {
      const { data } = await getApolloClient().query({
        query: GET_INTEGRATION_CONNECTIONS_FOR_TENANT,
        variables: { tenantId },
      });

      const connections = data?.getIntegrationConnectionsForTenant ?? [];
      const schema = data?.getIntegrationInitializationSchema;
      const platformByIntegrationId: Record<string, SupportedIntegrationPlatform> =
        {};

      (schema as IntegrationInitializationSchema[] | null | undefined)?.forEach(
        (row) => {
          platformByIntegrationId[row.integrationId] = row.platform;
        },
      );

      return { connections, platformByIntegrationId };
    } catch (error) {
      console.error('Error fetching integration connections for tenant:', error);
      return null;
    }
  },
};
